import Link from "next/link";

export default function Centered({ fields, first = false, sys, includes }) {
  const titleParts = fields.title && fields.title.split(" ");
  const last = titleParts.pop();
  const Title = ({ children }) => {
    return first
      ? <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl">{children}</h1>
      : <h3 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl">{children}</h3>
  }
  return (
    <section className="mt-16 mx-auto max-w-7xl px-4 sm:mt-24">
      <div className="text-center">
        {fields.title && (
          <Title>
            <span className="block xl:inline">{titleParts.join(" ")}</span>
            {last && (
              <span className="block text-brand-600 xl:inline"> {last}</span>
            )}
          </Title>
        )}
        {fields.text && (
          <p className="mt-3 max-w-md mx-auto text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
            {fields.text}
          </p>
        )}
        <div className="mt-5 max-w-lg mx-auto sm:flex sm:justify-center md:mt-8">
          {fields.actions &&
            fields.actions.map((action, index) => (
              <div
                className={`rounded-md shadow ${index !== 0 ? "md:ml-4" : ""}`}
                key={`${action.sys.id}-${index}`}
              >
                <Link
                  href={action.fields.link}
                  className={`w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-sans rounded-md ${
                    index === 0
                      ? "text-white bg-brand-600 hover:bg-brand-700"
                      : "text-brand-500-700 bg-brand-100 hover:bg-brand-200"
                  } md:py-4 md:text-lg md:px-10`}
                  >
                  {action.fields.text}
                </Link>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
}
